/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export const USER_AUTH_FINISHED = "USER_AUTH_FINISHED";
export const USER_AUTH_FAILED = "USER_AUTH_FAILED";
export const USER_AUTH_STARTED = "USER_AUTH_STARTED";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CURRENT_USER_CHOSEN_NAME = "SET_CURRENT_USER_CHOSEN_NAME";
export const LOAD_PROJECT = "LOAD_PROJECT";
export const SET_PROJECT_NAME = "SET_PROJECT_NAME";
export const SET_PROJECT_ANONYMOUS_ACCESS_KEY =
  "SET_PROJECT_ANONYMOUS_ACCESS_KEY";
export const SET_FILTER = "SET_FILTER";
export const STUDIO_SOUND_ASSET_CREATED = "STUDIO_SOUND_ASSET_CREATED";
export const ASSET_PROCESSING_FAILED = "ASSET_PROCESSING_FAILED";
export const ASSET_VIDEO_PROCESSING_COMPLETED =
  "ASSET_VIDEO_PROCESSING_COMPLETED";
export const PROJECT_ENHANCEMENT_FAILED = "PROJECT_ENHANCEMENT_FAILED";
export const SET_PLAYER_PLAYBACK_PROGRESS = "SET_PLAYER_PLAYBACK_PROGRESS";
export const SET_PLAYER_STATE = "SET_PLAYER_STATE";
export const SET_INITIAL_ASSETS_LOADED = "SET_INITIAL_ASSETS_LOADED";
export const SET_CLIP_ESTIMATED_DURATION = "SET_CLIP_ESTIMATED_DURATION";
export const INSERT_ASSET = "INSERT_ASSET";
export const ASSET_LOADED = "ASSET_LOADED";
export const ASSET_LOAD_FAILED = "ASSET_LOAD_FAILED";
export const CLIP_UPLOADED = "CLIP_UPLOADED";
export const ASSET_UPLOAD_STARTED = "ASSET_UPLOAD_STARTED";
export const ASSET_UPLOAD_PROGRESS = "ASSET_UPLOAD_PROGRESS";
export const ASSET_UPLOAD_FAILED = "ASSET_UPLOAD_FAILED";
export const SEEK_TO = "SEEK_TO"; // NOTE: This is dispatched only for logging purposes, it is no longer reduced anywhere

export const REPLACE_CLIPS = "REPLACE_CLIPS";
export const SET_CLIP_IS_BACKGROUND = "SET_CLIP_IS_BACKGROUND";
export const TOGGLE_EFFECT = "TOGGLE_EFFECT";
export const SET_PLACEHOLDER_TEXT = "SET_PLACEHOLDER_TEXT";

export const SET_SELECTION = "SET_SELECTION";
export const STOP_SELECTION_DRAGGING = "STOP_SELECTION_DRAGGING";
export const SET_PASTE_BUFFER = "SET_PASTE_BUFFER";

export const PARTICIPANT_WEBSOCKET_CONNECTING =
  "PARTICIPANT_WEBSOCKET_CONNECTING";
export const PARTICIPANT_WEBSOCKET_SUBSCRIBED =
  "PARTICIPANT_WEBSOCKET_SUBSCRIBED";
export const PARTICIPANT_WEBSOCKET_UNSUBSCRIBED =
  "PARTICIPANT_WEBSOCKET_UNSUBSCRIBED";
export const PARTICIPANT_MUTED = "PARTICIPANT_MUTED";
export const PARTICIPANT_UNMUTED = "PARTICIPANT_UNMUTED";
export const PARTICIPANT_LEFT_PROJECT = "PARTICIPANT_LEFT_PROJECT";
export const PARTICIPANT_WEBRTC_CONNECTION_CHANGED =
  "PARTICIPANT_WEBRTC_CONNECTION_CHANGED";
export const PARTICIPANT_RECEIVED_TRACK_UPDATE =
  "PARTICIPANT_RECEIVED_TRACK_UPDATE";
export const PARTICIPANT_RECORDING_SESSION_UPLOAD_SUCCEEDED =
  "PARTICIPANT_RECORDING_SESSION_UPLOAD_SUCCEEDED";
export const PARTICIPANT_RECORDING_SESSION_UPLOAD_FAILED =
  "PARTICIPANT_RECORDING_SESSION_UPLOAD_FAILED";
export const PARTICIPANT_MIC_SAMPLE = "PARTICIPANT_MIC_SAMPLE";
export const RECORDING_UPLOAD_FAILED = "RECORDING_UPLOAD_FAILED";

export const RECORDING_STARTING = "RECORDING_STARTING";
export const IMPORT_RECORDING_SESSION_INTO_PLACEHOLDER =
  "IMPORT_RECORDING_SESSION_INTO_PLACEHOLDER_CLIP";
export const RECORDING_STOPPING = "RECORDING_STOPPING";
export const INSERT_RECORDING_SESSION = "INSERT_RECORDING_SESSION";
export const RECORDING_STARTED = "RECORDING_STARTED";
export const RECORDING_STOPPED = "RECORDING_STOPPED";
export const RECORDING_UPLOADED = "RECORDING_UPLOADED";
export const RECORDING_DENIED = "RECORDING_DENIED";
export const UPDATE_RECORDING_DURATION = "UPDATE_RECORDING_DURATION";
export const RECORDING_RECOVERED = "RECORDING_RECOVERED";
export const RECORDING_SESSION_RECOVERY_FAILED =
  "RECORDING_SESSION_RECOVERY_FAILED";
export const RECORDING_SESSION_TRACK_RECOVERY_FAILED =
  "RECORDING_SESSION_TRACK_RECOVERY_FAILED";

export const RECORDING_SESSION_PROCESSING_REQUEST =
  "RECORDING_SESSION_PROCESSING_REQUEST";
export const RECORDING_SESSION_PROCESSING_STARTED =
  "RECORDING_SESSION_PROCESSING_STARTED";
export const RECORDING_SESSION_PROCESSING_SUCCEEDED =
  "RECORDING_SESSION_PROCESSING_SUCCEEDED";
export const RECORDING_SESSION_ALREADY_FINALIZED =
  "RECORDING_SESSION_ALREADY_FINALIZED";
export const RECORDING_SESSION_CHUNK_UPLOAD_FAILED =
  "RECORDING_SESSION_CHUNK_UPLOAD_FAILED";

export const TRANSCRIBE_ASSET_PROCESS = "TRANSCRIBE_ASSET_PROCESS";
export const TRANSCRIBE_ASSET_SUCCESS = "TRANSCRIBE_ASSET_SUCCESS";
export const TRANSCRIBE_ASSET_FAILURE = "TRANSCRIBE_ASSET_FAILURE";
export const ASSET_WAVEFORM_COMPUTED = "ASSET_WAVEFORM_COMPUTED";
export const ASSET_WAVEFORM_COMPUTATION_STARTED =
  "ASSET_WAVEFORM_COMPUTATION_STARTED";
export const UPDATE_LOCAL_TRANSCRIPT = "UPDATE_LOCAL_TRANSCRIPT";
export const UPDATE_SPEAKER_DISPLAY_NAME = "UPDATE_SPEAKER_DISPLAY_NAME";

export const SAVE = "SAVE";
export const SYNC_TRANSCRIPTS = "SYNC_TRANSCRIPTS";

export const SET_INPUT_DEVICE = "SET_INPUT_DEVICE";
export const SET_OUTPUT_DEVICE = "SET_OUTPUT_DEVICE";

export const ADD_TOAST = "ADD_TOAST";
export const REMOVE_TOAST = "REMOVE_TOAST";

export const CONVERT_PROJECT_TEMPLATE_REQUEST =
  "CONVERT_PROJECT_TEMPLATE_REQUEST";
export const CONVERT_PROJECT_TEMPLATE_SUCCESS =
  "CONVERT_PROJECT_TEMPLATE_SUCCESS";
export const ACCEPT_SESSION_INTERSTITIAL = "ACCEPT_SESSION_INTERSTITIAL";
export const SHOW_INVITE_GUESTS_POPUP = "SHOW_INVITE_GUESTS_POPUP";

export const SET_SERVER_TIME_OFFSET_MS = "SET_SERVER_TIME_OFFSET_MS";

export const DRAG_OVER_TARGET = "DRAG_OVER_TARGET";
export const DRAG_OVER_STOPPED = "DRAG_OVER_STOPPED";
export const DRAG_ENDED = "DRAG_ENDED";
export const DRAG_STARTED = "DRAG_STARTED";

export const SET_MUSIC_COLLECTION_CURRENTLY_PREVIEWING_TRACK_URL =
  "SET_MUSIC_COLLECTION_CURRENTLY_PREVIEWING_TRACK_URL";

export const RESET_PROJECT_STATE = "RESET_PROJECT_STATE";
export const SET_STREAMING = "SET_STREAMING";
export const SET_SHOW_VIDEO_PREVIEW = "SET_SHOW_VIDEO_PREVIEW";

export const SET_ENHANCE_SPEECH_MODEL_VERSION =
  "SET_ENHANCE_SPEECH_MODEL_VERSION";
